import React, { FC, useMemo } from 'react';
import { appStore } from '@store';
import { useT } from 'hooks';
import img1 from './img/img1.png';
import img1_webp from './img/img1.webp';
import img2 from './img/img2.png';
import img2_webp from './img/img2.webp';
import checkTheme from 'utils/custom/checkTheme';

import * as S from './styled';

export const MainScreen: FC = () => {
	const { answers } = appStore.surveyStore;
	const { T } = useT();
	const darkTheme = checkTheme() === 'darkMode' ? 'darkMode' : '';

	const userBMI = answers.ob_current_weight
		? JSON.parse(answers.ob_current_weight[0]).textBmi
		: 'overweight';
	const userPilatesLevel = answers.ob_flexible ? answers.ob_flexible[0] : 'just_started';

	const bodyFatLevel = useMemo(() => {
		switch (userBMI) {
			case 'overweight':
			case 'obese':
				return 'High';
			case 'normal':
				return 'Elevated';
			default:
				return 'High';
		}
	}, [userBMI]);

	const pilatesLevel = useMemo(() => {
		switch (userPilatesLevel) {
			case 'pretty_flexible':
				return 'High';
			case 'just_started':
				return 'Beginner';
			case 'not_good':
				return 'Basic';
			case 'not_sure':
				return 'Low';
			default:
				return 'Beginner';
		}
	}, [userPilatesLevel]);

	return (
		<S.Container>
			<S.Wrapper>
				<S.Label>Now</S.Label>
				<S.Label>Your goal</S.Label>
			</S.Wrapper>
			<S.ImgWrapper darkTheme={darkTheme}>
				<picture>
					<source srcSet={img1_webp} type='image/webp' />
					<img src={img1} alt='before' />
				</picture>
				<picture>
					<source srcSet={img2_webp} type='image/webp' />
					<img src={img2} alt='after' />
				</picture>
			</S.ImgWrapper>
			<S.Wrapper>
				<S.InfoWrapper>
					<S.InfoHeader>
						<p>Body fat</p>
						<S.InfoTitle>{bodyFatLevel}</S.InfoTitle>
					</S.InfoHeader>
					<S.Line />
					<S.InfoFooter>
						<p>Pilates level</p>
						<S.InfoTitle>{pilatesLevel}</S.InfoTitle>
						<S.Scale value={pilatesLevel === 'High' ? 2 : 1}>
							<div></div>
							<div></div>
							<div></div>
						</S.Scale>
					</S.InfoFooter>
				</S.InfoWrapper>
				<S.InfoWrapper>
					<S.InfoHeader>
						<p>Body fat</p>
						<S.InfoTitle>Normal</S.InfoTitle>
					</S.InfoHeader>
					<S.Line />
					<S.InfoFooter>
						<p>Pilates level</p>
						<S.InfoTitle>Advanced</S.InfoTitle>
						<S.Scale value={3}>
							<div></div>
							<div></div>
							<div></div>
						</S.Scale>
					</S.InfoFooter>
				</S.InfoWrapper>
			</S.Wrapper>
		</S.Container>
	);
};
